import basicOptions from '@/router/basic-options';
import { routeName } from '@/constants/routeName';
import Text from '@/views/DesignSystem/Text/index.vue';
import Form from '@/views/DesignSystem/Form/index.vue';
import Button from '@/views/DesignSystem/Button/index.vue';
export default [
    {
        path: 'design-system/text',
        name: routeName.DESIGN_SYSTEM_TEXT,
        component: Text,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'design-system/form',
        name: routeName.DESIGN_SYSTEM_FORM,
        component: Form,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'design-system/button',
        name: routeName.DESIGN_SYSTEM_BUTTON,
        component: Button,
        meta: {
            ...basicOptions,
        },
    },
];
